import { Link } from "react-router-dom";
import { ArrowRight, MapPin, Clock, MessageCircle } from "lucide-react";
import { UI, PATHS } from "@/i18n/ui";
import { SITE, waLink, HOURS } from "@/data/site";

export const ClinicSidebar = ({ lang, prefix, waText, showMaps = true }) => {
  const t = UI[lang];
  const p = PATHS[lang];
  return (
    <div className="rounded-2xl border border-[#E5E1D8] bg-white p-8 sticky top-24 space-y-5">
      <div className="flex gap-3">
        <MapPin size={18} className="shrink-0 text-[#4A6B53] mt-0.5" />
        <p className="text-sm text-[#4B5563] leading-relaxed">
          {SITE.address.street}, {SITE.address.area}, {SITE.address.city}, {SITE.address.region} {SITE.address.postal}
        </p>
      </div>
      <div className="flex gap-3">
        <Clock size={18} className="shrink-0 text-[#4A6B53] mt-0.5" />
        <p className="text-sm text-[#4B5563] leading-relaxed">{HOURS[lang]}</p>
      </div>
      {showMaps && (
        <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-maps-btn`}
          className="flex items-center justify-center gap-2 rounded-full border border-[#4A6B53] text-[#4A6B53] text-sm font-medium px-6 py-3 hover:bg-[#4A6B53]/5 transition-colors">
          <MapPin size={15} /> {t.misc.openMaps}
        </a>
      )}
      <Link to={p.booking} data-testid={`${prefix}-book-btn`}
        className="flex items-center justify-center gap-2 rounded-full bg-[#4A6B53] text-white font-medium px-6 py-3.5 hover:bg-[#3A5542] transition-colors">
        {t.cta.book} <ArrowRight size={15} />
      </Link>
      <a href={waLink(waText)} target="_blank" rel="noopener noreferrer" data-testid={`${prefix}-whatsapp-btn`}
        className="flex items-center justify-center gap-2 rounded-full border border-[#E5E1D8] text-[#1F2937] text-sm font-medium px-6 py-3 hover:border-[#4A6B53] transition-colors">
        <MessageCircle size={15} /> {t.cta.whatsapp}
      </a>
    </div>
  );
};
